import { TypeOf } from '@guiker/shared-framework'

import { createSeriesSchema } from './create-series-schema'

export const updateSeriesSchema = createSeriesSchema

export type UpdateSeriesSchema = TypeOf<typeof updateSeriesSchema>
